import { createI18n } from 'vue-i18n';
import enMessages from './locales/en.json';
import deMessages from './locales/de.json';
import nlMessages from './locales/nl.json';
import esMessages from './locales/es.json';
import config from '@/config';

const messages = {
    en: enMessages,
    de: deMessages,
    nl: nlMessages,
    es: esMessages
};

const i18n = createI18n({
    locale: config.DefaultLanguage,
    fallbackLocale: 'nl',
    warnHtmlMessage: false,
    messages,
    silentTranslationWarn: true
});

const originalT = i18n.global.t;

i18n.global.t = function (key, params = {} as Record<string, any>) {
    // @ts-ignore for spread operator
    return originalT(key, { ...params, sitename: config.Sitename });
};

export default i18n;
